module.exports = __webpack_public_path__ + "static/banner-two-shape6-08e0d8226ab082dfdcd02c61da4a0362.png";